/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/ustrichnye-bary-v-moskve'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import OysterBarTestLanding from '@routes/OysterBarTest';

export const Route = createFileRoute('/ustrichnye-bary-v-moskve')({
  staticData: { layout: { landingFooter: true, withoutHeader: true, withoutFooter: true } },
  component: () => (
    <CacheDataRoute component={OysterBarTestLanding} path='/ustrichnye-bary-v-moskve' />
  )
});
